<template>
  <div
    v-if="!client.hasOwnProperty('active')"
    class="tag-wrapper"
    @mouseleave="showTable = false"
  >
    <!--    @click="fillterMain('end')"-->
    <span
      v-if="client.deposits_log.length <= 0"
      class="label"
      :class="
        client.not_interested_state_id === 18
          ? 'tag-not-interested-ended table-tag-content'
          : 'tag-not-interested table-tag-content '
      "
      @mouseenter="showTable = true"
    >
      <span
        v-if="client.not_interested_state_id !== null ? false : true"
        @click.prevent="
          $emit('cancelAssign');
          showCancelAssign = false;
        "
        class="fas fa-hourglass-start"
      >
      </span>
      <!--              @click="fillterMain('ni')"-->
      <span class="niRes" v-if="client.not_interested_state_id !== null"
        >{{ client.not_interested_state.short_name
        }}<span
          class="last-online-time"
          v-if="
            checkLastOnline() && !showRemove && client.deposits_log.length > 0
          "
        >
          | {{ formatDateTime(client.last_online)
          }}<span class="online"></span></span></span
      ><span class="niPending" v-else></span>
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
      ></a>
    </span>

    <div
      v-if="showTable && client.ni.length > 0"
      class="tag-table pop-up-for-tags"
      @mouseenter="showTable = false"
    >
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>FullName</th>
              <th>Res</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in client.ni" :key="item.id">
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ formatDateTable(item.updated_at) }}
              </td>
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ item.updated_at | shortTime }}
              </td>
              <td>{{ item.user.full_name }}</td>
              <td>{{ findReason(item.state_id).name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapState } from "vuex";

export default {
  name: "NI",
  props: {
    client: {
      type: Object,
      required: true
    },

    showRemove: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showTable: false
    };
  },
  computed: {
    ...mapState("clients", ["NITimer", "dictionaries", "generalQueryObject"])
  },
  mounted() {},
  watch: {},
  methods: {
    checkSelectedCalDates(ldDit) {
      let ldIn = moment(ldDit.created_at);
      let start = moment(
        this.generalQueryObject.group_assigned_at_from
      ).startOf("day");
      let to = moment(this.generalQueryObject.group_assigned_at_to).endOf(
        "day"
      );
      if (ldIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    // fillterMain(tag) {
    //   if (tag === "ni") {
    //     this.$store.commit("clients/setFilterToMain", {
    //       title: "ni",
    //       type: true
    //     });
    //   }
    //   if (tag === "end") {
    //     this.$store.commit("clients/setFilterToMain", {
    //       title: "end",
    //       type: true
    //     });
    //   }
    // },
    findReason(x) {
      return this.dictionaries.activity.not_int_states.find(
        reason => reason.id === x
      );
    },
    checkLastOnline() {
      const now = moment().subtract(2, "hours"); //todays date
      const end = moment(String(this.client.last_online)); //.format("HH:mm")//.format("HH:mm");//moment("2015-12-1"); // another date
      const diff = now.diff(end, "minutes");
      if (diff < 720 && diff >= 0) {
        // return diff + " m";
        return true;
      }
      if (diff > 720) {
        //return 0 + " m";
        return false;
      }
    },

    formatDateTable(date) {
      return moment(String(date)).format("DD/MM ");
    },
    formatDateTime(date) {
      return moment(String(date)).format("HH:mm ");
    }
  }
};
</script>

<style scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
  text-align: center;
}

.tag-not-interested {
  background-color: #000000;
  /*margin: 3px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*text-transform: uppercase;*/
  /*animation: flash linear 1s;*/
  /*font-size: 12px;*/
  min-width: 36px !important;
  max-width: 80px !important;
  text-align: center !important;
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-not-interested-ended {
  background-color: #004d40;
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  min-width: 36px !important;
  max-width: 46px !important;
}

.tag-table {
  bottom: 34px !important;
  left: 2px !important;

  border: solid 1px #000000;
}

.table-responsive {
  /*margin-bottom: -18px;*/
  border-radius: 5px;
}
.table {
  margin-bottom: 0px !important;
}

.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 0px;*/
  /*position: absolute;*/
  /*left: 11px;*/
  /*font-size: 17px;*/
  /*padding-top: 2px;*/
  /*padding-bottom: 2px;*/
  /*padding-left: 6px;*/
  /*padding-right: 6px;*/
  /*border: 1px solid black;*/
  /*border-radius: 5px;*/
  /*top: 6px;*/
  /*background: black;*/
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
/*.remove-tag-icon:hover {*/
/*  color: white;*/
/*  background: black;*/
/*}*/
/*.remove-tag-icon:hover {*/
/*  color: #f44336;*/
/*}*/

.fa-hourglass-start {
  cursor: pointer;
}
.online {
  height: 8px;
  width: 8px;
  background-color: yellow;
  border-radius: 50%;
  position: absolute;
  top: 6px;
  right: 5px;
}
.last-online-time {
  margin-right: 8px;
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 11px;
  /*display: none;*/
}
.niRes:hover {
  font-size: 12px !important;
}
.inBetweenSelectedCalDates {
  /*background: lightgrey;*/
  /*border: 1px solid white !important;*/
  color: blue;
}
tbody > tr:nth-of-type(odd) {
  background-color: lightgrey;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
</style>
